import { render } from "./InfoCard.vue?vue&type=template&id=42eac1b6&scoped=true&bindings={\"id\":\"props\",\"iconColor\":\"props\",\"cardName\":\"props\",\"cardData\":\"props\",\"subName\":\"props\",\"icon\":\"props\",\"convertToMinutes\":\"setup\"}"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&id=42eac1b6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42eac1b6"

export default script